<template>
  <div class="login">
    <LoginForm @login="processLogin" @clear-error="clearError" :error="error" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoginForm from '@/components/Login.vue'

export default {
  name: 'Login',
  components: { LoginForm },
  data() {
    return {
      error: null,
      count: 0
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user' })
  },
  methods: {
    ...mapActions({ login: 'user/login' }),
    async processLogin(payload) {
      const { email, password } = payload
      this.count++
      if (!email || !password) {
        this.error = 'Please make sure both email and password are entered.'
        return
      }
      try {
        await this.login({ email, password })
        switch (this.user.role) {
          case 'super':
            return this.$router.push('/super/orgs')
          case 'admin':
            return this.$router.push('/admin/users')
          case 'audit':
            return this.$router.push('/plans/select')
          case 'manage':
            return this.$router.push('/plans/select')
          case 'report':
            return this.$router.push('/reports/dashboard')
          default:
            break
        }
      } catch (err) {
        this.error = 'There was an error logging in. Please try again.'
      }
    },
    clearError() {
      this.error = null
    }
  },
  mounted() {

  },
  beforeDestroy() {
    this.$off('login', this.processLogin)
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";

.login {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $brand-gradient;
}
</style>
